<div class="wrapper">
  <div class="iw-signin-dialog">
    <div class="header iw-bold-18">
      <iw-logo />
    </div>

    <div class="body">
      <div class="content">
        <div class="text">
          <p
            class="title d-flex flex-col align-center text-center"
            translate="signin.tfaCodes.header"
          ></p>
          <p class="message" translate="signin.tfaCodes.message1"></p>

          <p class="message" translate="signin.tfaCodes.message2"></p>
        </div>

        <div class="codes">
          <div class="column">
            @for (code of column1(); track code) {
              <div class="code">{{ code }}</div>
            }
          </div>
          <div class="column">
            @for (code of column2(); track code) {
              <div class="code">{{ code }}</div>
            }
          </div>
        </div>

        <div class="actions">
          <button
            type="button"
            fuButton
            size="l"
            uiType="secondary"
            translate="signin.tfaCodes.btn.copy"
            (click)="copy(codes())"
          ></button>

          <button
            type="button"
            fuButton
            size="l"
            uiType="primary"
            translate="signin.tfaCodes.btn.ok"
            (click)="ok()"
          ></button>
        </div>
      </div>
    </div>
  </div>
</div>
